export default {
  response: { organisationName: '', personalName: '', infoInn: {}, pinConfirmInfo: {} },
  errors: { getName: '', checkInn: '', checkPin: '' },
  loading: { innOrganisation: false, innPersonal: false, checkInn: false, checkPin: false },
  nextStep: ''
}
